exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.addressselect .item {\n    padding-right: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/happypack/loader.js?id=css!./~/vue-loader/lib/style-compiler?{"id":"data-v-5e70e3e2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/addressselect.vue
// module id = 521
// module chunks = 23